import React from 'react'

import { useDispatch } from 'react-redux'

import { messageToAccountantActions } from '@services'

/** Opens the message-to-accountant slide over from anywhere in the app. */
export function useOpenSupportSlideOver() {
  const dispatch = useDispatch()

  return React.useCallback(() => {
    dispatch(messageToAccountantActions.setSlideOverOpen.request(true))
  }, [dispatch])
}
